import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { WA } from "@/constants/testIds";
import { whatsappHref } from "@/constants/contact";

export default function FloatingWhatsAppButton() {
  const [pulse, setPulse] = useState(false);
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setPulse(true), 3800);
    const t2 = setTimeout(() => setPulse(false), 5200);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  return (
    <div
      className="fixed z-[60]"
      style={{
        right: "max(16px, env(safe-area-inset-right))",
        bottom: "max(18px, env(safe-area-inset-bottom))",
      }}
    >
      <div className="relative flex items-center">
        {showTip && (
          <div
            className="hidden sm:block absolute right-full mr-3 whitespace-nowrap bg-white text-brand-navy text-sm font-medium px-3 py-2 rounded-lg shadow-lg border border-brand-border"
            role="tooltip"
          >
            Chat with us on WhatsApp
            <span className="absolute right-[-5px] top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-white rotate-45 border-r border-t border-brand-border" />
          </div>
        )}
        <a
          data-testid={WA.button}
          href={whatsappHref()}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with Ascend Tech Solutions on WhatsApp"
          onMouseEnter={() => setShowTip(true)}
          onMouseLeave={() => setShowTip(false)}
          onFocus={() => setShowTip(true)}
          onBlur={() => setShowTip(false)}
          className={`flex items-center justify-center w-[54px] h-[54px] sm:w-[60px] sm:h-[60px] rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] hover:scale-[1.06] hover:shadow-[0_14px_36px_-6px_rgba(37,211,102,0.65)] transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-[#25D366]/40 ${pulse ? "animate-pulse-once" : ""}`}
        >
          <FaWhatsapp className="w-7 h-7 sm:w-8 sm:h-8" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
